import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import { tokens } from "../theme";

const StatBox = ({
  title,
  subtitle,
  icon,
  progress,
  achieved,
  target,
  remaining,
  increase,
  measurementName,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      width="100%"
      m="0 30px"
      p="20px"
      borderRadius="8px"
      sx={{
        backgroundColor: colors.primary[400],
        boxShadow: `0 4px 8px ${colors.grey[900]}`,
        transition: "transform 0.3s, box-shadow 0.3s",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: `0 8px 16px ${colors.grey[900]}`,
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: colors.grey[100] }}
          >
            {title}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: colors.grey[400] }}>
            {measurementName}
          </Typography>
        </Box>

        <Tooltip title={title} arrow placement="top">
          <Box
            sx={{
              backgroundColor: colors.greenAccent[500],
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: colors.grey[100],
            }}
          >
            {icon}
          </Box>
        </Tooltip>
      </Box>

      {/* Achieved / Target / Remaining */}
      <Box display="flex" justifyContent="space-between" mt="15px">
        <Box textAlign="center">
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[400], fontWeight: "bold" }}
          >
            {achieved}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.grey[300], mr:2 }}>
            Achieved
          </Typography>
        </Box>

        <Box textAlign="center">
          <Typography
            variant="h6"
            sx={{ color: colors.greenAccent[500], fontWeight: "bold" }}
          >
            {target}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.grey[300] }}>
            Target
          </Typography>
        </Box>

        <Box textAlign="center">
          <Typography
            variant="h6"
            sx={{ color: colors.redAccent[400], fontWeight: "bold" }}
          >
            {remaining}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.grey[300] }}>
            Remaining
          </Typography>
        </Box>
      </Box>

      {progress && (
        <Box mt="15px" display="flex" alignItems="center">
          <Box width="100%" mr="10px">
            <Box
              height="8px"
              borderRadius="4px"
              sx={{ backgroundColor: colors.grey[700] }}
            >
              <Box
                height="100%"
                width={`${Math.min(progress, 100)}%`}
                borderRadius="4px"
                sx={{
                  backgroundColor:
                    progress > 70
                      ? colors.greenAccent[500]
                      : progress > 40
                      ? colors.blueAccent[500]
                      : colors.redAccent[500],
                  transition: "width 0.5s ease-in-out",
                }}
              />
            </Box>
          </Box>
          <Typography variant="body2" sx={{ color: colors.grey[300] }}>
            {progress}%
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default StatBox;
